<template>
  <div class="vocRemovalBody" :class="!isMobile?'navTheme':''" v-if="vocabLoaded">
    <div class="vocRemovalInside">
      <div id="vocRemovalInfo">
        <h3 style="font-weight: bold">
          Voici les 10 mots que tu vas apprendre <template v-if="!isMobile">pour cet épisode</template> !
        </h3>
      </div>
      <h3 class="reviewTitle" v-if="reviewLemmas.length>0">
        Révisions
      </h3>
      <div class="reviewList flexwrap">
        <div v-for="(word, index) in reviewLemmas"
             :key="index"  :class="[vocab.length-lemmasToRemove.length>10?'clickable':'']"
             @click="addLemmaToRemove(word, index)">
          <learnt-word :key="word.lemma.english"
                       :lemma="word.lemma">
          </learnt-word>
        </div>
      </div>

      <!--<infobulle id="vocRemovalInfo" class="lightStandardTheme">
        <template v-slot:content>
          Voici les 10 mots que tu vas apprendre ! <br/>
          Clique sur ceux que tu connais déjà si tu veux les remplacer. (5 maximum)
        </template>
      </infobulle>-->

      <h3 class="learnTitle">
        Nouveaux mots
      </h3>
      <div class="learnList flexwrap">

        <div v-for="(word, index) in newLemmas"
             :key="index"  :class="[vocab.length-lemmasToRemove.length>10?'clickable':'']"
             @click="addLemmaToRemove(word)">
          <learnt-word :key="word.lemma.english"
                       :lemma="word.lemma">
          </learnt-word>

        </div>
      </div>
      <div class="vertical-line2" v-if="lemmasToRemove.length>0"></div>

      <div class="removeList flexwrap" v-if="lemmasToRemove.length>0">
        <div v-for="(word, index) in lemmasToRemove"
             :key="index" class="clickable"
             @click="putBackWord(word)">
          <learnt-word :key="word.lemma.english"
                       :lemma="word.lemma"
                       :to_delete="true"
                       style="margin-bottom: 0.5vw">
          </learnt-word>
        </div>



      </div>
      <span id="removeWordsInstructions" v-else>Clique sur ceux qui sont trop faciles pour les remplacer.</span>

      <standard-button id="vocRemovalvalidate" @click="removeLemmas()" :color-class="'blue'">Démarrer</standard-button>
      <div v-if="isMobile"></div>
    </div>

  </div>
  <div class="vocRemovalBody" :class="!isMobile?'navTheme':''" v-else>
  <loading-logo></loading-logo>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import LoadingLogo from "@/components/loadingLogo";

export default {
  name: "vocabularyCardWordsRemoval",

  components: {
    LoadingLogo,
    StandardButton: () => import(/* webpackPrefetch: true */ '@/components/standardButton.vue'),
    //Infobulle,
    learntWord: () => import(/* webpackPrefetch: true */ '@/components/learntWord.vue')
  },

  props: {
    vocab: Array,
    vocabLoaded: Boolean
  },

  created() {
  },

  watch:{
    'vocabLoaded': function(){

      this.vocab.forEach((word, index) => {
        word['place'] = index;
      })
    }
  },

  computed: {
    ...mapGetters('global', [
      'isMobile',
    ]),
    lemmasToLearn: function() {
      /*if(this.$isDebug) {
        return this.vocab
      }
      else*/ return this.vocab.slice(0,10)
    },


    newLemmas: function (){
      return this.lemmasToLearn.filter((word) => {
        if(word.lemma.user_lemma.length > 0) {
          return word.lemma.user_lemma[0].knowledge_level === 0
        }
        else {
          return word.lemma.user_lemma.length === 0
        }
      })
    },

    reviewLemmas: function (){
      return this.lemmasToLearn.filter((word) => {
        if(word.lemma.user_lemma.length > 0) {
          return word.lemma.user_lemma[0].knowledge_level > 0
        }
      })
    },
  },

  methods: {
    ...mapActions('session', [
        'set_currentComponent',
        'add_lemmasToRemoveIds'
    ]),
    addLemmaToRemove(word) {
      if(this.vocab.length>10) {
        this.lemmasToRemove.push(word)
        this.lemmasToRemove.sort((a,b) => {return a.place - b.place})
        // On retrouve l'index du mot dans la liste d'origine
        let wordIndex = -1
        this.vocab.forEach((element, index) => {
          if(element.id === word.id) {
            wordIndex = index
          }
        })
        this.vocab.splice(wordIndex, 1)
      }
    },

    putBackWord(word) {
      this.vocab.push(word)
      this.vocab.sort((a,b) => {return a.place - b.place}).slice(0,10)
      // On retrouve l'index du mot dans la liste d'origine
      let wordIndex = -1
      this.lemmasToRemove.forEach((element, index) => {
        if(element.id === word.id) {
          wordIndex = index
        }
      })
      this.lemmasToRemove.splice(wordIndex, 1)
    },

    removeLemmas() {
      this.lemmasToRemove.forEach((word) => {
        this.add_lemmasToRemoveIds(word.lemma.id)
      })
      this.vocab.splice(10);
      this.set_currentComponent("vocabularyCardWord");
    }
  },

  data() {
    return {
      lemmasToRemove: []
    }
  }
}
</script>

<style scoped>
  .vocRemovalBody{
    padding: 1vw;
    overflow: hidden;
    border-radius: 1vw;
  }
  .vocRemovalInside{
    display: grid;
    grid-template-columns: 2fr auto 1fr;
    grid-template-rows: auto auto auto auto 1fr auto;
    grid-gap: 0.5vw;
    height: calc(100% - 2vw);
    align-content: flex-start;
  }

  #vocRemovalInfo{
    grid-row: 1/2;
    grid-column: 1/4;
    text-align: center;
  }

  .reviewList {
    display: flex;
    grid-column: 1/2;
    align-items: flex-start;
    justify-items: center;
    justify-content: flex-start;
    align-content: flex-start;
    overflow: auto;
  }

  .reviewTitle {
    font-weight: bold; grid-column: 1/2;
  }

  .learnList {
    display: flex;
    grid-column: 1/2;
    align-items: flex-start;
    justify-items: center;
    justify-content: flex-start;
    align-content: flex-start;
    overflow: auto;
  }

  .learnTitle {
    font-weight: bold; grid-column: 1/2;
  }

  .vertical-line2{
    grid-row: 2/6;
    grid-column: 2/3;
    width: 0.2vw;
    border-radius: 0.1vw;
    height:100%;
    background-color: var(--lightColor);
    justify-self: center;
    color: #00000000;
  }


  .removeList {
    display: flex;
    /*flex-direction: column;*/
    grid-row: 2/6;
    grid-column: 3/4;
    align-items: flex-start;
    justify-items: center;
    justify-content: center;
    align-content: flex-start;
    overflow: auto;
  }

  #vocRemovalvalidate{
    grid-row: 6/7;
    grid-column: 1/4;
  }

  #removeWordsInstructions{
    grid-row: 2/6;
    grid-column: 2/4;
    font-style: italic;
    /*font-size: 0.9em;*/
    opacity: 0.9;
    align-self: flex-end;
  }

  @media screen and (max-device-width: 767px) {
    .vocRemovalInside{
      display: grid;
      grid-template-columns: 1fr;
      grid-template-rows: auto auto auto auto auto auto 1fr auto 1fr;
      padding: 2vw;
      grid-gap: 2vw;
      max-height: calc(100% - 4vw);
    }

    #vocRemovalInfo{
      padding: 2vw 6vw 2vw 2vw;
    }


    .learnList {
      font-size: 1em;
    }


    .reviewList {
      font-size: 1em;
    }

    .vertical-line2{
      grid-column: 1/2;
      grid-row: 6/7;
      height: 0.8vw;
      border-radius: 0.4vw;
      width:100%;
      background-color: var(--goalBackgroundColor3);
    }
    .removeList {
      grid-column: 1/2;
      grid-row: 7/8;

      flex-direction: row;
      justify-items: flex-start;
      align-content: flex-start;
      font-size: 0.8em;
    }

    #vocRemovalvalidate{
      grid-column: 1/2;
      grid-row: 8/9;
    }

    #removeWordsInstructions{
      grid-column: 1/2;
      grid-row: 6/8;
      text-align: center;
      font-size: 0.9em;
    }

  }
</style>